




import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AnalysesList from "./AnalysesList.vue";
import { Analysis } from "@/api/analyses/types";
import * as analysesApi from '@/api/analyses/index';
import { FarmListRow } from "@/api/farms/types";
import EventBus from "@/event-bus";

@Component({
  name: "AnalysesListController",
  components: {
    AnalysesList,
  }
})
export default class AnalysesListController extends Vue {
  @Prop({type: String, required: false})
  private farmUuid!: string | null;
  
  private analysesList: Analysis[] = [];
  private analysisType = 'ANALITICA';

  private mounted() {
    EventBus.$on("new:analysis", this.reloadAnalyses);
  }

  @Watch('farmUuid', {immediate: true})
  private async onFarmChange(farmUuid: string | null) {
    if (!farmUuid) {
      this.analysesList = [];
      return;
    }

    try {
      this.analysesList = (await analysesApi.getAnalysisByFarmUuid(farmUuid)).data;
    } catch(err) {
      this.analysesList = [];
    }
  }

  private async reloadAnalyses() {
    await this.onFarmChange(this.farmUuid);
  }

  private createAnalysis(analysisType: string) {
    EventBus.$emit('analysis:create', {analysisType, farm: {uuid: this.farmUuid} as FarmListRow});
  }
}
